import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import CONSTANTS from '../../_constants/constants';
import TIME_ZONES from '../../_constants/time-zones';

import { MetaData } from '../interfaces/metaData';
import { ModalDialogService } from './modal-dialog.service';
import { CropImageComponent } from '../components/crop-image/crop-image.component';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  // TODO: move this to sharingModule
  private checkUncheckItemsSubject$ = new BehaviorSubject<any>({
    showListActions: false,
    totalItemsSelected: 0,
    masterCheckboxSelected: false,
  });

  constructor(
    private translateService: TranslateService,
    private modalDialogService: ModalDialogService
  ) {}

  checkUncheckAllItems(items, event, currentItemId = null) {
    let masterCheckboxSelected = event.target.checked;

    let restCounter = 0;

    items.forEach((item) => {
      if (
        item.is_default ||
        item.predefined ||
        item.id === currentItemId ||
        item.used_in_transactions
      ) {
        // Not evaluate hidden checkboxes
        restCounter = restCounter + 1;
      } else {
        item.isSelected = masterCheckboxSelected;
      }
    });

    this.checkUncheckItemsSubject$.next({
      showListActions: masterCheckboxSelected,
      totalItemsSelected: items.length - restCounter,
      masterCheckboxSelected: masterCheckboxSelected,
    });
  }

  checkUncheckItem(items, item, event) {
    item.isSelected = event.target.checked;

    let itemsSelected = items.reduce((total, item) => {
      if (item.isSelected) return total + 1;
      return total;
    }, 0);

    this.checkUncheckItemsSubject$.next({
      showListActions: itemsSelected > 0 ? true : false,
      totalItemsSelected: itemsSelected,
      masterCheckboxSelected: false,
    });
  }

  restoreListActions() {
    this.checkUncheckItemsSubject$.next({
      showListActions: false,
      totalItemsSelected: 0,
      masterCheckboxSelected: false,
    });
  }

  getCheckboxsSubjectValue(): Observable<any> {
    return this.checkUncheckItemsSubject$.asObservable();
  }

  // For item list
  checkItemStatus(status) {
    if (status === 'inactive' || status === false) {
      return 'disabled';
    }

    return '';
  }

  // Show icon on the right
  checkInputStatusClass(input) {
    let inputClass = '';

    if (input.pending) {
      inputClass = 'input_pending';
    } else if (input.valid) {
      inputClass = 'input_success';
    } else if (input.invalid && input.touched) {
      inputClass = 'input_error';
    }

    return inputClass;
  }

  // Wrapper error class
  checkInputErrorClass(input) {
    let inputClass = '';

    if (input !== undefined && input.touched && input.invalid) {
      // scope.formErrors ||
      inputClass = 'has-error';
    }

    return inputClass;
  }

  changeItemRowStyle(id) {
    // hack
    setTimeout(() => {
      const tr = document.getElementById(id);

      tr.className += ' changed';

      setTimeout(() => {
        tr.className = tr.className.replace('changed', 'restore');
      }, 1000);
    }, 100);
  }

  getItemsMetaData(response, filterCriteria) {
    let itemsPerPage = CONSTANTS.ITEMS_PER_PAGE;

    const totalPages = Math.ceil(response.meta.itemsFound / itemsPerPage);

    const meta: MetaData = {
      totalItems: response.meta.totalItems,
      itemsFound: response.meta.itemsFound,
      itemsPerPage: itemsPerPage,
      totalPages: totalPages,
      startItemNumber: 1,
      endItemNumber: 0,
    };

    if (filterCriteria.page > 1) {
      meta.startItemNumber = (filterCriteria.page - 1) * itemsPerPage + 1;
    }

    meta.endItemNumber = meta.startItemNumber + response.data.length - 1;

    return meta;

    // let totalPages = Math.ceil(response.meta.itemsFound / itemsPerPage);
    // totalPages: totalPages,
  }

  productTypesFormArrayChecked(data, dataFormArray) {
    let typesChecked = {};

    let types = data.filter((productType, productTypeIndex) =>
      dataFormArray.controls.some(
        (control, controlIndex) => productTypeIndex === controlIndex && control.value
      )
    );

    for (let productType of types) {
      typesChecked[productType.type] = true;
    }

    return typesChecked;

    // for (let productType of this.productTypes) {
    //   if (productType['isSelected']) {
    //     typesChecked[productType.type] = true; // add only true values to objet
    //   }
    // }
  }

  setFormServerErrors(errors) {
    let serverErrors = [];

    for (let field in errors) {
      if (errors.hasOwnProperty(field)) {
        serverErrors[field] = errors[field].join(', ');
      }
    }

    return serverErrors;
  }

  showInlineMessage(message: string) {
    return this.translateService.instant(message);

    // let msg = '';
    // this.translateService.get(message).subscribe((message) => {
    //   msg = message;
    // });

    // return msg;
  }

  // ?
  parseItemIds(checkedItems) {
    let data = [];

    for (let key in checkedItems) {
      if (checkedItems[key]) {
        // Add only true values to objet
        data.push(key); // key
      }
    }

    return data;
  }

  // Convert string data to array of buffer for save the xlsx file
  s2ab(str) {
    const s = atob(str);
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);

    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i);
    } // & 0xFF

    return buf;
  }

  cleanItemsCache = function (items, field) {
    const random = new Date().toString();

    items.forEach(function (item) {
      if (item[field] && item[field]['url']) {
        item.logoUrl = item[field]['url'] + '?cb=' + random;
      }
    });

    return items;
  };

  cleanItemCache(item, field) {
    const random = new Date().toString();

    const image = item[field] && item[field]['url'] ? item[field]['url'] + '?cb=' + random : '';

    return image;
  }

  embedYouTubeVideo(video) {
    return video ? video.replace('watch?v=', 'embed/') : '';
  }

  deleteEmptyFields(fields, params) {
    fields.forEach((field) => {
      if (!params[field]) {
        delete params[field];
      }
    });

    return params;
  }

  deleteNullFields(fields, params) {
    fields.forEach((field) => {
      if (params[field] === null) {
        delete params[field];
      }
    });

    return params;
  }

  setFilterCriteria(filterCriteria, field, value) {
    filterCriteria.page = 1;
    filterCriteria.offset = null;
    // scope.filterCriteria.offset = (scope.filterCriteria.page - 1) * scope.meta.itemsPerPage;

    if (value) {
      filterCriteria[field] = value;
    } else {
      delete filterCriteria[field];
    }

    return filterCriteria;
  }

  scrollToTop(to = 'html') {
    document.querySelector(to).scrollIntoView({ behavior: 'smooth' });
  }

  openLogo(successCallback) {
    // , width = '', height = ''

    const options = {
      width: '600px',
      disableClose: true,
      position: { top: '5vh' },
      data: {
        title: 'ADD_IMAGE',
        // obj: item,
        // params: {
        // width: width,
        // height: height,
        // },
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, CropImageComponent);
  }

  groupTimeZonesByValue() {
    const options = [];

    TIME_ZONES.forEach(function (data) {
      data.cities.forEach(function (city) {
        options.push({
          value: data.value,
          abbr: data.abbr,
          offset: data.offset,
          isdst: data.isdst,
          utc: data.utc,
          city: city,
        });
      });
    });

    const zones = options.reduce((acc, { value, abbr, offset, isdst, utc, city }) => {
      if (!acc[value]) {
        acc[value] = { value: value, cities: [] };
      }

      acc[value].cities.push({
        value: value,
        abbr: abbr,
        offset: offset,
        isdst: isdst,
        utc: utc,
        city: city,
      });

      return acc;
    }, {});

    return Object.values(zones);
  }

  // groupArrayBy(array, key) {
  //   return array.reduce((rv, x) => {
  //     (rv[x[key]] = rv[x[key]] || []).push(x);
  //     return rv;
  //   }, {});
  // }

  selectInputPattern(pattern) {
    let ALLOW_PATTERN;

    switch (pattern) {
      case 'alpha':
        ALLOW_PATTERN = /^[a-z\s]+$/;
        break;
      case 'numbers':
        ALLOW_PATTERN = /^[\d\s]+$/;
        break;
      case 'alphanumeric':
        ALLOW_PATTERN = /^[a-z\d\s]+$/;
        break;
      case 'phone':
        ALLOW_PATTERN = /^[\d- ]+$/; // numbers and - and spaces
        break;
      case 'currency':
        ALLOW_PATTERN = /^[\d.]+$/; // numbers and .
        break;
      case 'map':
        ALLOW_PATTERN = /^[\d.-]+$/;
        break;
      case 'email':
        ALLOW_PATTERN = /^[a-z\@\d._-]+$/;
        // ALLOW_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$/;
        break;
      case 'text':
        ALLOW_PATTERN =
          /^[a-zA-Z0-9\Á\á\É\é\Í\í\Ó\ó\Ú\ú\Ñ\ñ\_\=\+\-\*\'\"\?\¿\!\¡\.\:\,\#\$\&\/\(\)\ ]*$/;
        break;
      case 'username':
        ALLOW_PATTERN = /^[a-z\d_]+$/; // ^[-\w]+$
        break;
      // case 'password':
      // numeric values \d
      // lowercase values a-z
      // uppercase values A-Z
      // special characters W
      // no whitespace allowed S
      // ALLOW_PATTERN = /^[\d\a-z\A-Z\W\S]+$/;

      // ALLOW_PATTERN =
      //   /\d+/, //numeric values
      //   /[a-z]+/, //lowercase values
      //   /[A-Z]+/, //uppercase values
      //   /\W+/, //special characters
      //   /^\S+$/, //no whitespace allowed
      // ;
      // break;
      default:
        ALLOW_PATTERN = pattern;
        break;
    }

    return ALLOW_PATTERN;
  }
}

// Check if there are changes in the form values - so we can avoid server load
// isFormDataChanged(item, itemCopy, fieldsDefinition) {
//   if (!itemCopy.id) return true;

//   return fieldsDefinition.some((field) => item[field] !== itemCopy[field]);
// }

// this.translateService.get(['']).subscribe(() => {
//   todayLabel = this.translateService.instant('TODAY');
//   yesterdayLabel = this.translateService.instant('YESTERDAY');
//   thisWeekLabel = this.translateService.instant('THIS_WEEK');
//   lastWeekLabel = this.translateService.instant('LAST_WEEK');
//   thisMonthLabel = this.translateService.instant('THIS_MONTH');
//   lastMonthLabel = this.translateService.instant('LAST_MONTH');
//   nextMonthLabel = this.translateService.instant('NEXT_MONTH');
// });
